<template>
  <b-row>
    <!-- Modal Description -->
    <b-modal v-model="modalDesc.show" hide-footer title="Description">
      {{ modalDesc.data || '-' }}
    </b-modal>

    <!-- Modal Export Import RH -->
    <b-modal
      v-model="showModalImport"
      title="Import Data"
      ok-title="Submit"
      @ok="handleImport"
    >
      <template #modal-header>
        <h5 class="text-primary">Import Data</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImport = false"
        ></i>
      </template>
      <template>
        <div class="flex flex-column align-items-center">
          <b-form-file
            v-model="importFile"
            type="file"
            class="form-control"
            accept=".xlsx, .xls, .csv"
          />
          <small class="text-black">accept: .xlsx, .xls, .csv</small>
        </div>
        <b-button
          variant="outline-primary"
          class="mt-3 w-100"
          @click="handleExport"
        >
          <i class="fa fa-download"></i>
          Download Template
        </b-button>
      </template>
    </b-modal>
    <!-- End Modal Export Import RH -->

    <!-- Modal Import Errors -->
    <b-modal
      v-model="showModalImportErrors"
      title="Import Errors"
      ok-only
      size="lg"
    >
      <template #modal-header>
        <h5 class="text-danger">Import Failed - Error Details</h5>
        <i
          class="fa fa-times cursor-pointer"
          @click="showModalImportErrors = false"
        ></i>
      </template>
      <div class="table-responsive">
        <table class="table table-bordered table-sm">
          <thead class="thead-light">
            <tr>
              <th style="width: 100px">Row #</th>
              <th>Error Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(error, index) in importErrors" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ error }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <!-- End Modal Import Errors -->

    <b-col sm="12">
      <iq-card>
        <template v-slot:headerTitle>
          <h4 class="card-title text-primary">
            <strong>Equipment Category test</strong>
          </h4>
        </template>

        <template v-slot:body>
          <div class="d-flex justify-content-between">
            <div class="d-flex mb-3">
              <b-form @submit.prevent="fetchData">
                <b-form-input
                  v-model="equipmentCategory.params.search"
                  style="width: 200px"
                  type="text"
                  class="mr-2"
                  placeholder="Search..."
                  @input="debouncedSearch"
                  @keyup.enter="fetchData"
                ></b-form-input>
              </b-form>
              <div style="width: 350px">
                <v-select
                  v-model="equipmentCategory.params.vehicleTypeIds"
                  id="fleet"
                  multiple
                  placeholder="Select Vehicle Type"
                  label="name"
                  :options="typeFleet"
                  :reduce="(opt) => opt.code"
                ></v-select>
              </div>
              <div style="width: 120px" class="mx-2">
                <v-select
                  v-model="equipmentCategory.params.active"
                  id="status"
                  placeholder="Select Status"
                  label="label"
                  :options="statusOptions"
                  :reduce="(opt) => opt.value"
                  :clearable="false"
                ></v-select>
              </div>
              <div>
                <b-button type="button" variant="primary" @click="fetchData">
                  <i class="fa fa-sliders"></i>
                  Apply Filter
                </b-button>
              </div>
            </div>
            <div class="d-flex">
              <b-button
                variant="outline-primary"
                class="d-flex align-items-center mr-2"
                style="height: max-content"
                @click="showModalImport = true"
              >
                <i class="ri-upload-2-line pl-1"></i>
                Import
              </b-button>
              <b-button
                variant="primary"
                @click="openSidebar()"
                style="height: max-content"
              >
                <i class="fa fa-plus mr-1"></i>
                New Data
              </b-button>
            </div>
          </div>

          <!-- List -->
          <div class="table-responsive">
            <table
              v-if="equipmentCategory.data?.length"
              class="table table-bordered table-striped"
            >
              <thead class="thead-light">
                <tr>
                  <th>Job Name</th>
                  <th>Used For</th>
                  <th>Description</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in equipmentCategory.data"
                  :key="index"
                >
                  <td>{{ item.component_name }}</td>
                  <td>
                    <span
                      v-for="(
                        type, i
                      ) in item.maintenance_component_vehicle_types"
                      :key="i"
                      class="badge badge-light border mr-1"
                    >
                      {{ type?.vehicle_type?.name }}
                    </span>
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-outline-primary"
                      @click="
                        () => {
                          modalDesc.show = true
                          modalDesc.data = item.description
                        }
                      "
                    >
                      Description
                    </button>
                  </td>
                  <td align="center">
                    <span v-if="item.active" class="badge badge-primary">
                      Active
                    </span>
                    <span v-else class="badge badge-danger">In Active</span>
                  </td>
                  <td align="center">
                    <b-dropdown
                      size="sm"
                      variant="outline-primary"
                      text="Action"
                      right
                    >
                      <b-dropdown-item @click.prevent="openSidebar(item)">
                        Edit
                      </b-dropdown-item>
                      <b-dropdown-item
                        @click.prevent="deleteItem(item)"
                        class="text-danger"
                      >
                        Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="w-100 text-center py-5">
              <p class="text-muted">No Data Here!</p>
            </div>
            <div
              v-if="equipmentCategory.data?.length"
              class="mt-4 d-flex align-items-center w-100 justify-content-end"
            >
              <b-pagination
                class="mb-0 mr-3"
                @input="fetchData"
                v-model="equipmentCategory.params.page"
                :total-rows="equipmentCategory.params.total"
                :per-page="equipmentCategory.params.limit"
                first-number
                align="center"
              ></b-pagination>
              <b-form-select
                plain
                v-model="equipmentCategory.params.limit"
                :options="limitOptions"
                style="width: 140px"
                @input="() => fetchData()"
              ></b-form-select>
            </div>
          </div>
        </template>
      </iq-card>
    </b-col>

    <!-- Custom Sidebar -->
    <custom-sidebar
      v-model="showSidebar"
      size="lg"
      :title="`${
        equipmentCategory.editMode ? 'Edit' : 'New'
      } Equipment Category`"
    >
      <b-form
        @submit.prevent="handleSubmit"
        class="p-4 bg-white"
        style="border-radius: 10px"
      >
        <b-form-group
          label="Equipment Category Name *"
          label-for="project_location"
        >
          <b-form-input
            v-model="equipmentCategory.form.component_name"
            type="text"
            placeholder="Equipment Category Name"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Used For *" label-for="fleet">
          <v-select
            v-model="equipmentCategory.form.vehicle_type_ids"
            id="fleet"
            multiple
            placeholder="Select Vehicle Type"
            label="name"
            :options="typeFleet"
            :reduce="(opt) => opt.code"
          ></v-select>
        </b-form-group>

        <b-form-group label="Description" label-for="Description">
          <b-form-textarea
            v-model="equipmentCategory.form.description"
            id="notes"
            rows="3"
            placeholder="Description"
          ></b-form-textarea>
        </b-form-group>

        <!-- <b-form-group label="Parent" label-for="parent">
          <v-select
            v-model="equipmentCategory.form.parent_id"
            label="component_name"
            placeholder="Select parent"
            :options="equipmentCategoryParents"
            :reduce="(opt) => opt.id"
          ></v-select>
        </b-form-group> -->

        <b-form-group label="Status *" label-for="active">
          <b-form-checkbox
            v-model="equipmentCategory.form.active"
            name="check-button"
            switch
            inline
          >
            <template v-if="equipmentCategory.form.active === false">
              No
            </template>
            <template v-else>Yes</template>
          </b-form-checkbox>
        </b-form-group>

        <hr />
        <div class="d-flex">
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-3 w-50"
            @click="closeSidebar"
          >
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" class="w-50">
            {{ equipmentCategory.editMode ? 'Save' : 'Add' }}
          </b-button>
        </div>
      </b-form>
    </custom-sidebar>
  </b-row>
</template>

<script>
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'
import CustomSidebar from '@/src/components/global/CustomSidebar.vue'
import { limitOptions } from '@/src/core/mock/data/optionsData'
import { debounce } from 'lodash'

export default {
  name: 'MasterEquipmentCategory',
  components: { CustomSidebar },
  data() {
    return {
      showModalImport: false,
      showModalImportErrors: false,
      importFile: null,
      importErrors: [],
      modalDesc: {
        data: null,
        show: false,
      },
      showModalFilter: false,
      limitOptions,
      statusOptions: [
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
      ],
      typeFleet: [],
      equipmentCategoryParents: [],
      showSidebar: false,
      equipmentCategory: {
        editMode: false,
        params: {
          search: '',
          vehicleTypeIds: [],
          active: true,
          page: 1,
          limit: 10,
          total: 10,
          totalPages: 1,
        },
        data: [],
        form: {
          parent_id: null,
          component_name: '',
          description: '',
          vehicleTypeId: [],
          active: true,
        },
        detailData: null,
      },
    }
  },
  methods: {
    ...fleetsActions,
    ...pmsActions,
    debouncedSearch: debounce(function () {
      this.equipmentCategory.params.page = 1 // Reset to first page when searching
      this.fetchData()
    }, 1000),
    resetFilter() {
      // Reset semua filter ke nilai default
      this.equipmentCategory.params.search = ''
      this.equipmentCategory.params.vehicleTypeIds = []
      this.equipmentCategory.params.active = true
      this.equipmentCategory.params.page = 1

      // Apply filter setelah reset
      this.fetchData()
    },
    async handleImport() {
      try {
        const formData = new FormData()
        formData.append('file', this.importFile)
        const res = await this.importEquipmentCategory(formData)
        console.log({ res })
        this.$swal({
          title: 'Import Data Success',
          icon: 'success',
        })
      } catch (error) {
        console.log('Import Error:', error)
        const errorList = error?.data?.data?.errors || []
        if (errorList.length > 0) {
          this.importErrors = errorList
          this.showModalImportErrors = true
        } else {
          this.$swal({
            title: 'Failed Import Data!',
            type: 'error',
            text: 'Failed Import Data please check your file import!',
            icon: 'error',
          })
        }
      } finally {
        this.fetchData()
      }
    },
    async handleExport() {
      try {
        const res = await this.exportTemplateEquipmentCategory()
        saveAs(res.data, 'template_master_equipment_category.xlsx')
        this.$swal({
          title: 'Download Template Success',
          text: res.message,
          icon: 'success',
        })
      } catch (error) {
        this.$swal({
          title: 'Failed Export Template',
          icon: 'error',
        })
      }
    },
    openSidebar(data) {
      this.showSidebar = true
      if (data) {
        this.equipmentCategory.editMode = true
        this.equipmentCategory.detailData = data
        this.equipmentCategory.form = {
          parent_id: data.parent_id,
          component_name: data?.component_name,
          description: data.description,
          vehicle_type_ids: data.maintenance_component_vehicle_types?.map(
            (el) => el?.vehicle_type_id
          ),
          active: data.active,
        }
      } else {
        this.equipmentCategory.editMode = false
        this.equipmentCategory.detailData = null
        this.equipmentCategory.form = {
          parent_id: null,
          component_name: '',
          description: '',
          vehicle_type_ids: [],
          active: true,
        }
      }
    },

    closeSidebar() {
      this.showSidebar = false
    },

    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchData(page = 1) {
      const res = await this.getEquipmentCategory({
        ...this.equipmentCategory.params,
        page,
        vehicleTypeId: this.equipmentCategory.params.vehicleTypeIds?.toString(),
      })
      console.log('data', res.data.data)

      if (res.status === 'success') {
        this.equipmentCategory.data = res.data.data
        this.equipmentCategory.params = {
          ...this.equipmentCategory.params,
          ...res.data.pagination,
        }
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchDataParent() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipmentCategory(params)
      if (res.status === 'success') {
        const filteredData = res.data.data.filter((el) => !el.parent_id)
        console.log({ filteredData })

        this.equipmentCategoryParents = filteredData
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async handleSubmit() {
      if (this.equipmentCategory.form.parent_id) {
        this.equipmentCategory.form.parent_id = Number(
          this.equipmentCategory.form.parent_id
        )
      }

      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          swal.showLoading()
        },
      })

      if (this.equipmentCategory.editMode) {
        const res = await this.updateEquipmentCategory({
          id: this.equipmentCategory.detailData.id,
          data: this.equipmentCategory.form,
        })
        if (res.status === 'success') {
          this.$swal('Update Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      } else {
        const body = {
          ...this.equipmentCategory.form,
          alias: this.equipmentCategory.form.component_name
            .toLowerCase()
            .replace(' ', '_'),
        }
        const res = await this.createEquipmentCategory(body)
        if (res.status === 'success') {
          this.$swal('Add Success!', res.data.message, 'success')
          this.fetchData()
          this.showSidebar = false
        } else {
          this.$swal(`Oops!`, res.data.message, 'error')
        }
      }
    },

    deleteItem(dataVal) {
      this.$swal({
        title: 'Delete Equipment Category?',
        text: `${dataVal.text} will be deleted and cannot be recovered.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Delete',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let res = await this.deleteEquipmentCategory(dataVal.id)
          if (res.status === 'success') {
            this.fetchData()
            this.$swal(
              `Deleted!`,
              `Equipment Category ${dataVal.equipment_name} successfully deleted`,
              'success'
            )
          } else {
            this.$swal('Error', res.data.message || 'Server error', 'error')
          }
        }
      })
    },
  },
  mounted() {
    this.getVehicleTypeData()
    this.fetchData()
    this.fetchDataParent()
  },
}
</script>
